/** @module csi/dgrid/HeightMixin */
define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/dom-style",
	"dojo/query",
	"dojo/sniff",
	"csi/_base/underscore",
	"csi/html"
], function(declare, domClass, domStyle, query, sniff, _, html) {

	return declare(null, {
		/** @property {boolean} bUseMaxHeight=true - use initial height derived from CSS as maximum available height; if false, then adjust height to fit content */
		bUseMaxHeight: true,

		/** @property {number} _heightNumRows - number of rendered rows */
		_heightNumRows: 0,

		refresh: function(options) {
			var self = this;
			var dfd = this.inherited(arguments);
			if (dfd) {
				dfd.then(function(results) {
					self._heightNumRows = results.length;
					self._heightUpdate();
				});
			}

			return dfd;
		},

		resize: function() {
			this.inherited(arguments);
			this._heightUpdate();
		},

		/**
		 * Adjust grid height to fit content up to desired maximum (if any)
		 */
		_heightUpdate: function() {
			const {bUseMaxHeight, bodyNode, domNode, footerNode, headerNode, rowHeight, _columnSetScrollers, _heightNumRows} = this;

			domStyle.set(this.domNode, html.HEIGHT, "");

			const maxHeight = bUseMaxHeight ? html.preciseHeight(domNode) : Infinity;
			const headerHeight = html.preciseHeight(headerNode);
			const footHeight = html.preciseHeight(footerNode);
			let height = headerHeight + footHeight + rowHeight * _heightNumRows;

			// add 1 to height for Firefox
			if (sniff("ff")) {
				++height;
			}

			if (_columnSetScrollers) {
				height += _.reduce(_columnSetScrollers, (memo, scroller) => Math.max(memo, html.preciseHeight(scroller)), 0);
			}

			if (height < maxHeight) {
				// Firefox requires special styling for last row, so add CSS class to target it
				if (sniff("ff")) {
					const lastRow = query(".dgrid-row", bodyNode).last();
					if (lastRow) {
						domClass.add(lastRow, "csi-dgrid-row-last");
					}
				}

				html.setPixels(domNode, html.HEIGHT, height);
			}
		}
	});
});
